import type { IsoDate } from "./types.js";
import { daysBetween, formatDate } from "./dates.js";

// 期程與目標斜線的唯一來源在 shared/，後端也讀同一份。
export {
  PLAN_START, PLAN_END, TARGET_END_DATE, TARGET_END_WEIGHT
} from "../../shared/plan.js";
import {
  PLAN_START, PLAN_END, TARGET_END_DATE, TARGET_END_WEIGHT
} from "../../shared/plan.js";

/** 畫面上寫賽事目標日的那幾個字。由 PLAN_END 推導，不要到處寫死 12/20。 */
export const RACE_DATE_LABEL = formatDate(PLAN_END);

/** 賽季的體重起點：畫目標斜線與算 Boss 血量用。由上一季的結算體重推導。 */
export interface SeasonBaseline {
  date: IsoDate;
  weight: number;
}

export interface Countdown {
  remaining: number;
  elapsed: number;
  total: number;
  progress: number;
  finished: boolean;
}

/** 距離賽事目標日的倒數。目標日當天與之後都視為完成。 */
export function countdownInfo(referenceDate: IsoDate): Countdown {
  const total = Math.max(1, daysBetween(PLAN_START, TARGET_END_DATE));
  const rawRemaining = daysBetween(referenceDate, TARGET_END_DATE);
  const remaining = Math.max(0, rawRemaining);
  const elapsed = Math.min(total, Math.max(0, daysBetween(PLAN_START, referenceDate)));
  const progress = Math.min(100, Math.max(0, elapsed / total * 100));
  const finished = rawRemaining <= 0;
  return { remaining, elapsed, total, progress, finished };
}

/** 把任意日期夾進計畫期間。今天在期間外時，操作對象退回最近的邊界。 */
export function clampToPlan(date: IsoDate): IsoDate {
  if (date < PLAN_START) return PLAN_START;
  if (date > PLAN_END) return PLAN_END;
  return date;
}

/** 目標體重斜線上某一天的值。 */
export function targetWeight(date: IsoDate, baseline: SeasonBaseline): number {
  const total = daysBetween(baseline.date, TARGET_END_DATE);
  const elapsed = daysBetween(baseline.date, date);
  return baseline.weight + (TARGET_END_WEIGHT - baseline.weight) * (elapsed / total);
}
